<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "CardDetailsPlaceHostel",
  props: {
    department_id: String,
    select_room_id: Number,
    full_name_place: String
  },
  data: () => ({
    headers_table_state: [
      {text: 'ФИО', value: 'full_name', sortable: false},
      {text: 'ПРИЗНАК', value: 'privilege', align: "center", sortable: false, filterable: false},
      {text: 'ПРИКАЗ', value: 'order', align: "center", sortable: false, filterable: false},
      {text: 'ДАТА РАЗМЕЩЕНИЯ', value: 'created_at', sortable: false, filterable: false},
      {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: "center", filterable: false},
    ],
    page: 1,
    pageCount: 0,
  }),
  computed: {
    ...mapState({
      list_distribution_statements: state => state.interactionStatement.list_distribution_statements
    })
  },
  methods: {
    ...mapActions({
      EvictionOfStudentFromRoom: 'interactionStatement/EvictionOfStudentFromRoom',
      GetStatementsForDepartment: 'interactionStatement/GetStatementsForDepartment',
      GetDetailsPlace: 'interactionStatement/GetDetailsPlace',
      GetObjectPlacesDormFac: 'placesInDormitories/GetObjectPlacesDormFac',
    }),
    transitionListPlaces() {
      this.$emit('transitionListPlaces')
    },
    async evictionFromRoom(statement_hostel_id) {
      await this.EvictionOfStudentFromRoom(statement_hostel_id)

      await this.GetDetailsPlace(this.select_room_id)
      await this.GetStatementsForDepartment(this.department_id)
      await this.GetObjectPlacesDormFac(this.department_id)
    }
  }
}
</script>

<template>
  <v-card
      outlined
      class="rounded-xl overflow-auto"
      width="100%"
      height="800px"
  >
    <v-card-title>
      <v-row>
        <v-col cols="12" class="d-flex">
          <v-btn
              rounded
              small
              @click="transitionListPlaces()"
              text
              color="teal"
              absolute
          >
            <v-icon left>
              fa fa-chevron-left
            </v-icon>
            Назад
          </v-btn>
          <h6
              class="mx-auto text-caption text-uppercase text--secondary"
          >
            Закрепление за комнатой
          </h6>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <div>
            {{ full_name_place }}
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
        :headers="headers_table_state"
        :items="list_distribution_statements"
        :items-per-page="12"
        :page.sync="page"
        :sort-by="['privilege','created_at']"
        :sort-desc="[false, true]"
        loading-text="Загрузка заявлений... пожалуйста подождите"
        @page-count="pageCount = $event"
        no-data-text="По предложенным критериям данные отсутствуют"
        hide-default-footer
        mobile-breakpoint="0"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn v-if="item.order === null" @click="evictionFromRoom(item.statement_hostel_id)" small icon>
          <v-icon size="15px">
            fa fa-times
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.order="{ item }">
        <v-icon v-if="item.order === null" size="15px" color="red">
          fa-file
        </v-icon>
        <v-icon v-else size="15px" color="green">
          fa-file
        </v-icon>
      </template>
      <template v-slot:item.status_commission.status_review="{ item }">
        <v-icon size="20px" :color="setStatus(item.status_commission.status_review).color">
          {{ setStatus(item.status_commission.status_review).icon }}
        </v-icon>
      </template>
      <template v-slot:item.privilege="{ item }">
        <v-icon
            v-if="item.privilege === 'Отсутствует' || item.privilege === 'отсутствует'"
            size="20px"
        >
          fa-universal-access
        </v-icon>
        <v-icon
            v-else
            size="20px"
            color="green"
        >
          fa-universal-access
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>

</style>